/**
 * features/letters/useLetters.ts
 * Live subscription to archived company documents, newest first.
 */
import { useEffect, useState } from 'react';
import { collection, onSnapshot, orderBy, query } from 'firebase/firestore';
import { db } from '@/lib/firebase';
import { COLLECTIONS, type CompanyDocument } from '@/types';

export function useLetters() {
  const [letters, setLetters] = useState<CompanyDocument[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const q = query(collection(db, COLLECTIONS.companyDocuments), orderBy('createdAt', 'desc'));
    return onSnapshot(
      q,
      (snap) => {
        setLetters(snap.docs.map((d) => ({ id: d.id, ...(d.data() as Omit<CompanyDocument, 'id'>) })));
        setLoading(false);
      },
      () => setLoading(false),
    );
  }, []);

  return { letters, loading };
}
